import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';




export const maxLength100 = Validation.maxLength(100);
export const maxLengthDropDown = Validation.dropdown.maxLength(50);




/**
 * Helper function to check if a maintenance type is chosen
 * @param {Object} allValues - All form values
 * @returns {boolean} - True if maintenance type is selected and not 'none'
 */
export const maintenanceChosen = (allValues) => {
  if (allValues?.maintenanceType && allValues?.maintenanceType !== 'none') {
    return true;
  }
  return false;
};

/**
 * Validates required fields in the Scheduling section
 * Only validates when a maintenance type is selected
 */
export const validateSchedulingRequired = (value, allValues) => {
  let realValue = value?.value || value;
  if (realValue === 'none') {
    realValue = null;
  }

  if (maintenanceChosen(allValues)) {
    return Validation.required(realValue);
  }

  return undefined;
};


export const validate_SchedulingDuration_MinValue = (value, allValues) => {
  // console.log('value ===> ', value);

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  return Validation.hoursMinutesMinMinutes('schedulingDuration', 1)(value, allValues);
};


export const validate_MinimumSplitBlock_MinValue = (value, allValues) => {
  // console.log('value ===> ', value);

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  if (!allValues?.splitEnabled) {
    return undefined;
  }

  return Validation.hoursMinutesMinMinutes('minimumSplitBlock', 0)(value, allValues);
};

export const validate_MaximumTotalDuration_MinValue = (value, allValues) => {
  // console.log('value ===> ', value);

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  if (!allValues?.splitEnabled) {
    return undefined;
  }

  // Calculate schedulingDuration in minutes to use as minimum value
  const schedulingDurationHours = allValues?.schedulingDuration_hours || 0;
  const schedulingDurationMinutes = allValues?.schedulingDuration_minutes || 0;
  const minMinutes = (parseInt(schedulingDurationHours, 10) * 60) + parseInt(schedulingDurationMinutes, 10);

  return Validation.hoursMinutesMinMinutes('maximumTotalDuration', minMinutes)(value, allValues);
};

/**
 * Validates Max Human Capacity is required
 * Only required when maintenance is chosen AND operation has manHours enabled
 */
export const validate_MaxHumanCapacity_Required = (value, allValues) => {
  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  // If no operation selected yet, don't validate
  if (!allValues?.operationName) {
    return undefined;
  }

  // Check if operation has manHours enabled (stored in hidden field)
  if (allValues?._manHoursEnabled !== true) {
    return undefined; // Skip validation if manHours is disabled
  }

  return Validation.required(value);
};

export const validate_MaxHumanCapacity_MinValue = (value, allValues) => {

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  // If no operation selected yet, don't validate
  if (!allValues?.operationName) {
    return undefined;
  }

  // Check if operation has manHours enabled (stored in hidden field)
  if (allValues?._manHoursEnabled !== true) {
    return undefined; // Skip validation if manHours is disabled
  }

  // Check that maxHumanCapacity is not lower than minHumanCapacity
  let minHumanCapacity = allValues?.minHumanCapacity || 0;
  if (value < minHumanCapacity) {

    let message = createLabelHelper('mat.administration.matsettings.kittypes.kitTypeForm.')
      .get('operations.humanCapacityMax.validation.maxIsLowerThanMin');

    return message;
  }

  // // Check that maxHumanCapacity is at least 1
  // return Validation.hoursMinutesMinMinutes('maximumTotalDuration', 1)(value, allValues);
};


/**
 * Validates time-based interval field
 * Only required when maintenance type is 'TIME_BASED'
 */
export const validate_MaintenanceTimeBasedInterval_Required = (value, allValues) => {

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  if (allValues?.maintenanceType !== 'TIME_BASED') {
    return undefined;
  }

  return Validation.daysHoursMinutesTimeRequired('timeBasedInterval')(value, allValues);

};

export const validate_MaintenanceTimeBasedInterval_MinValue = (value, allValues) => {

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  if (allValues?.maintenanceType !== 'TIME_BASED') {
    return undefined;
  }

  let MIN_MINUTES = 1 * 24 * 60; // 1 day in minutes

  return Validation.daysHoursMinMinutes('timeBasedInterval', MIN_MINUTES)(value, allValues);
};

/**
 * Validates usage-based interval field
 * Only required when maintenance type is 'USAGE_BASED'
 */
export const validate_MaintenanceUsageBasedInterval_Required = (value, allValues) => {

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  if (allValues?.maintenanceType !== 'USAGE_BASED') {
    return undefined;
  }

  return Validation.daysHoursMinutesTimeRequired('usageBasedInterval')(value, allValues);

};

export const validate_MaintenanceUsageBasedInterval_MinValue = (value, allValues) => {

  if (!maintenanceChosen(allValues)) {
    return undefined;
  }

  if (allValues?.maintenanceType !== 'USAGE_BASED') {
    return undefined;
  }

  let MIN_MINUTES = 1 * 24 * 60; // 1 day in minutes

  return Validation.daysHoursMinMinutes('usageBasedInterval', MIN_MINUTES)(value, allValues);
};


/**
 * Validates cycle-based interval field
 * Only required when maintenance type is 'CYCLE_BASED'
 */
export const validate_MaintenanceCycleBasedInterval_Required = (value, allValues) => {
  if (maintenanceChosen(allValues) && allValues?.maintenanceType === 'CYCLE_BASED') {
    return Validation.required(value);
  }
  return undefined;
};

/**
 * Validates scheduling duration field
 * Required when any maintenance type is selected
 */
export const validate_SchedulingDuration_Required = (value, allValues) => {
  if (maintenanceChosen(allValues)) {
    return Validation.timeRequired('schedulingDuration')(value, allValues);
  }
  return undefined;
};

/**
 * Validates minimum split block field
 * Only required when maintenance is chosen AND split is enabled
 */
export const validate_MinimumSplitBlock_Required = (value, allValues) => {
  if (maintenanceChosen(allValues) && allValues?.splitEnabled) {
    return Validation.timeRequired('minimumSplitBlock')(value, allValues);
  }
  return undefined;
};

/**
 * Validates maximum total duration field
 * Only required when maintenance is chosen AND split is enabled
 */
export const validate_MaximumTotalDuration_Required = (value, allValues) => {
  if (maintenanceChosen(allValues) && allValues?.splitEnabled) {
    return Validation.timeRequired('maximumTotalDuration')(value, allValues);
  }
  return undefined;
};

